import { Tooltip, Typography } from '@mui/material';
import { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { ErpPositionInvoiceKind } from '@work4all/models/lib/Enums/ErpPositionInvoiceKind.enum';

import { FixedDataPicker } from '../fixed-data-picker/FixedDataPicker';
import { IPickerProps } from '../types';

const ORDERED_ERP_POSITION_INVOICE_KIND = [
  ErpPositionInvoiceKind.STANDARD,
  ErpPositionInvoiceKind.ANZAHLUNGSRECHNUNG,
  ErpPositionInvoiceKind.TEILRECHNUNG,
  ErpPositionInvoiceKind.SCHLUSSRECHNUNG,
];

const ERP_POSITION_INVOICE_KIND_WITH_DIVIDER = [
  ErpPositionInvoiceKind.STANDARD,
  ErpPositionInvoiceKind.TEILRECHNUNG,
];

export type InvoicePositionKindPickerProps<TMultiple extends boolean> =
  IPickerProps<{ id: ErpPositionInvoiceKind; name: string }, TMultiple>;

export function InvoicePositionKindPicker<TMultiple extends boolean>(
  props: InvoicePositionKindPickerProps<TMultiple>
) {
  const { t } = useTranslation();
  const data = useMemo(() => {
    return ORDERED_ERP_POSITION_INVOICE_KIND.map((key) => {
      const id = ErpPositionInvoiceKind[key];

      return {
        id,
        name: t(`INVOICE_POSITION_KINDS.${id}`),
      };
    });
  }, [t]);

  const renderItemContent = useCallback(
    (kind) => {
      return (
        <Tooltip
          title={t(`INVOICE_POSITION_KINDS.TOOLTIP.${kind.id}`, '')}
          placement="left"
        >
          <Typography variant="body2" noWrap>
            {kind.name}
          </Typography>
        </Tooltip>
      );
    },
    [t]
  );

  return (
    <FixedDataPicker
      dataSet={data}
      optionsWithDivider={ERP_POSITION_INVOICE_KIND_WITH_DIVIDER}
      renderItemContent={renderItemContent}
      {...props}
    />
  );
}
